import React from "react";
import "./PageLayout.css";
import { connect } from "react-redux";

// import SideMenu from "./SideMenu";

class PageLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  render() {
    const { children, global_loading } = this.props;

    return (
      <div>
        {global_loading === true ? (
          <div>
            <div>
              <div className="g_loader">
                <div>
                  <div className="spinner">
                    <div className="bounce1" />
                    <div className="bounce2" />
                    <div className="bounce3" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        <>
          <main className="page-content">{children}</main>
        </>
      </div>
    );
  }
}

const mapStateToProps = ({ common }) => {
  const { global_loading } = common;
  return { global_loading };
};

export default connect(mapStateToProps)(PageLayout);
